import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Modal from "react-modal";

import { closeArticleViewer } from "Actions";
import CloseViewer from "../CloseViewer";
import Content from "./Content";

const customStyles = {
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "none",
    overflow: "none",
    padding: 0,
    top: "5%",
    left: "5%",
    right: "5%",
    bottom: "5%",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(41, 57, 77, 0.04)"
  }
};

class ArticleViewer extends PureComponent {
  handleAfterOpenModal() {}

  handleCloseModal() {
    this.props.closeArticleViewer();
  }

  render() {
    const { viewer } = this.props;

    if (!viewer.isOpen) {
      return false;
    }
    return (
      <Modal
        isOpen={viewer.isOpen}
        onAfterOpen={this.handleAfterOpenModal}
        onRequestClose={this.handleCloseModal.bind(this)}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
        contentLabel="Artcle Viewer"
      >
        <div className="rmodal" id="newArticleViewer">
          <CloseViewer closeViewer={this.props.closeArticleViewer} />
          <Content />
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  viewer: state.articleViewer
});

const mapDispatchToProps = dispatch => ({
  closeArticleViewer: () => dispatch(closeArticleViewer())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArticleViewer);



// WEBPACK FOOTER //
// ./src/components/Reveal/ArticleViewer/index.js